module.exports = __webpack_public_path__ + "img/2.dafeafe9.jpeg";